import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", testId }) => (
  <motion.div
    data-testid={testId}
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.25, 1, 0.5, 1] }}
  >
    {children}
  </motion.div>
);

export const Tag = ({ children, light = false }) => (
  <p
    className={`font-mono text-[11px] uppercase tracking-[0.25em] flex items-center gap-3 ${
      light ? "text-mint" : "text-emerald"
    }`}
  >
    <span className={`h-px w-8 inline-block ${light ? "bg-mint" : "bg-emerald"}`} />
    {children}
  </p>
);
